import React from 'react'
import { FormControl } from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import styled, { css } from 'styled-components'
import { $DCprimaryColor, $secondaryWithAlpha, colors } from '../../styleGuide'

const TypeAHead = (props) => {
  const {
    handleSearch,
    isLoading,
    data,
    labelKey,
    placeholder,
    onChange,
    isClearOnSelection,
    value,
    invalid,
    onSelectedOption,
    size,
    isShowIcon,
    icon,
    iconPosition,
    iconClick,
    ...rest
  } = props

  const filterBy = () => true
  const [options, setOptions] = React.useState(data)
  const ref: any = React.useRef()
  React.useEffect(() => {
    setOptions(data)
  }, [data])

  return (
    <AsyncTypeahead
      positionFixed={true}
      flip={true}
      renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
        // Filter out icon-related props from inputProps to prevent them from being passed to DOM
        const { iconPosition: _, isShowIcon: __, icon: ___, iconClick: ____, ...filteredInputProps } = inputProps
        
        return (
          <InputContainer>
            <CustomInput
              size={props.size}
              invalid={invalid.toString()}
              {...filteredInputProps}
              ref={(input) => {
                inputRef(input)
                referenceElementRef(input)
              }}
              $isShowIcon={isShowIcon}
              $iconPosition={iconPosition}
            />
            {isShowIcon && icon && (
              <IconButton
                iconPosition={iconPosition}
                onClick={iconClick}
                type="button"
                title="Click to scan product barcode/QR code"
              >
                {icon}
              </IconButton>
            )}
          </InputContainer>
        )
      }}
      id='async-pagination-example'
      autoComplete='off'
      style={{ overflow: 'visible' }}
      filterBy={filterBy}
      ref={ref}
      labelKey={labelKey || 'first_name'}
      isLoading={isLoading}
      onSearch={handleSearch}
      defaultInputValue={value}
      options={options}
      placeholder={props.placeholder}
      renderMenuItemChildren={props.formatter}
      onChange={(d) => {
        props.onChange(d)
        onSelectedOption(d)
        if (isClearOnSelection) {
          if (ref && ref.current) {
            ref?.current?.clear()
          }
        }
      }}
      {...rest}
    />
  )
}
const CustomInput = styled(FormControl)<{ props }>`
  /* border: 0.0625rem solid ${colors.grayBorder}; */
  border: none;
  color: ${colors.grayInputDark};
  appearance: none;
  background-clip: padding-box;
  border-radius: 0.375rem;
  display: block;
  position: none;
  font-size: 0.875rem;
  font-weight: 400;
  padding: ${(props) =>
    props.size === 'sm' ? '2px 0.5rem' : '0.5625rem 1.125rem !important'};
  width: 100%;
  line-height: 1.5rem;
  ${(props) =>
    props.showsearchicon === 0 &&
    css`
      padding-left: 35px !important;
    `}
  background-color: ${colors.white} !important;
  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}
  /* border: 1px solid ${colors.grayBorder} !important; */
  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
    box-shadow: 0 0 0 1px ${$DCprimaryColor} !important;
  }
  ${(props) =>
    props.invalid === 'true' &&
    css`
      color: ${colors.danger};
      &:focus {
        color: ${colors.danger};
      }
    `}
  ${(props) =>
    props.$isShowIcon &&
    props.$iconPosition === 'right' &&
    css`
      padding-right: 40px !important;
    `}
  ${(props) =>
    props.$isShowIcon &&
    props.$iconPosition === 'left' &&
    css`
      padding-left: 40px !important;
    `}
`

const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`

const IconButton = styled.button<{ iconPosition: 'left' | 'right' }>`
  position: absolute;
  ${(props) => (props.iconPosition === 'right' ? 'right: 8px' : 'left: 8px')};
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid ${colors.grayBorder};
  border-radius: 4px;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.grayInputDark};
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    color: ${$DCprimaryColor};
    background: rgba(255, 255, 255, 1);
    border-color: ${$DCprimaryColor};
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: none;
    border-color: ${$DCprimaryColor};
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }
`

export default TypeAHead
